import { useQuery } from 'react-query';

import { useServiceError } from '@/hooks';
import { SendOptionType } from '../SendOptions/SendOptions.types';
import { emailTagsByType } from './EmailTags.service';

export function useEmailTagsByType(type?: SendOptionType) {
  const mutation = useQuery(['emailTags', type], () => emailTagsByType(type), {
    enabled: !!type,
  });

  useServiceError(mutation.error);

  return mutation;
}
